import scope from "@/constants/Scope";

const settings = {
    categoryName: "sitemap",
    scope: scope,
  } as const;

  export default settings;